<template>
    <div class="col-lg-4 col-md-6 col-sm-12 result mb-4">
        <div class="card">
            <div class="placeholder-result-item" :style="{ 'min-height': this.payload.journey.return ? '400px' : '350px' }" v-show="payload.showPlaceholder">
                <skeleton-item></skeleton-item>
            </div>
            <div class="card-body" v-if="!payload.showPlaceholder">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                        <div class="mediums">
                            <div class="mediums d-flex align-items-center">
                                <div class="circle d-flex justify-content-center align-items-center text-center mr-2">
                                    <span class="d-block w-100">{{ stages.length }}</span>
                                </div>
                                <div v-for="(stage, index) in  getIconsAndNamesByStage(payload.journey, 'depart')" :key="index" class="medium text-center d-inline-block mr-3 stage-icon">
                                    <div class="icon-holder">
                                        <svg-icon aria-label="transport-icon" v-if="index" :name="stage.icon + '-colored'" width="auto" height="1.5em"></svg-icon>
                                        <svg-icon v-else aria-label="transport-icon" :name="stage.icon" width="auto" height="1.5em"></svg-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cost">
                            <div class="d-flex align-items-center">
                                <div class="wrapper">
                                    <strong>{{payload.journey.cost}}</strong>
                                </div>
                                <div class="wrapper">
                                    <svg-icon class="ml-2 forward-icon" name="forward"  width="8" height="auto"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 mt-3 text-center">
                        <div class="indicators d-inline-block">
                            <h3 class="text-left"> Outbound Journey : {{this.payload.journey.depart.departure_date}}</h3>
                            <div class="indicator-item d-inline-block pr-1">
                                <h3>Leave</h3>
                                <h3>{{ this.payload.journey.depart.departure_at }}</h3>
                            </div>
                            <div class="indicator-item d-inline-block px-1">
                                <svg-icon class="" name="dotted-line" width="30"></svg-icon>
                            </div>
                            <div class="indicator-item d-inline-block px-1">
                                <h3>Time</h3>
                                <h3>{{ this.payload.journey.depart.duration.text }}</h3>
                            </div>
                            <div class="indicator-item d-inline-block px-1">
                                <svg-icon class="" name="dotted-line" width="30"></svg-icon>
                            </div>
                            <div class="indicator-item d-inline-block pl-1">
                                <h3>Arrive</h3>
                                <h3>{{this.payload.journey.depart.arrival_at}}</h3>
                            </div>
                        </div>
                        <!-- return -->
                        <div class="col-12 mt-3 text-center">
                            <div v-if="this.payload.journey.return" class="indicators d-inline-block mt-3">
                                <h3 class="text-left"> Return Journey : {{this.payload.journey.return.departure_date}}</h3>
                                <div class="indicator-item d-inline-block pr-1">
                                    <h3>Leave</h3>
                                    <h3>{{this.payload.journey.return.departure_at }}</h3>
                                </div>
                                <div class="indicator-item d-inline-block px-1">
                                    <svg-icon name="dotted-line" width="30"></svg-icon>
                                </div>
                                <div class="indicator-item d-inline-block px-1">
                                    <h3>Time</h3>
                                    <h3>{{this.payload.journey.return.duration.text }}</h3>
                                </div>
                                <div class="indicator-item d-inline-block px-1">
                                    <svg-icon name="dotted-line" width="30"></svg-icon>
                                </div>
                                <div class="indicator-item d-inline-block pl-1">
                                    <h3>Arrive</h3>
                                    <h3>{{this.payload.journey.return.arrival_at}}</h3>
                                </div>
                            </div>
                        </div>
                        <!-- end of return -->
                        <div class="details row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <hr class="my-2">
                                    </div>
                                    <div class="col-lg-8 text-left">
                                        <p class="mb-1 px-2">Estimated wait time:</p>
                                    </div>
                                    <div class="col-lg-4 text-right pl-1">
                                        <p class="mb-1 px-2"><strong>{{ payload.journey.total_wait_time }} mins</strong> </p>
                                    </div>
                                    <div class="col-12">
                                        <hr class="my-2">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-8 text-left">
                                        <p class="mb-1 px-2">Estimated walking distance:</p>
                                    </div>
                                    <div class="col-lg-4 text-right">
                                        <p class="mb-1 px-2"><strong>{{ payload.journey.total_walking_distance }}</strong> </p>
                                    </div>
                                    <div class="col-12">
                                        <hr class="my-2">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-6 text-left">
                                        <p class="mb-1 px-2">Estimated total emissions:</p>
                                    </div>
                                    <div class="col-lg-6 text-right">
                                        <p :class="{'lowest': this.payload.journey.carbon_emission === lowestCarbon, 'highest': this.payload.journey.carbon_emission === highestCarbon}" class="mb-1 px-2"><strong>{{ payload.journey.carbon_emission}} kg CO<sub>2</sub></strong> </p>
                                    </div>
                                    <div class="col-12">
                                        <hr class="my-2">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!payload.showPlaceholder" class="card overlay">
                <b-button @click="seeDetails" class="full-green-btn">
                    <span>View journey details <svg-icon v-if="brand != 'sestran'" class="forward-icon-on-button" name="forward"></svg-icon></span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SkeletonItem from './SkeletonItem.vue'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    name: 'result-item',
    props: ['payload', 'journeyType', 'lowestCarbon', 'highestCarbon'],
    components: {
        SkeletonItem,
    },
    data() {
        return {
            hash: this.$route.params.hash,
            brand: whitelabel.brand,
        }
    },
    computed: {
        ...mapGetters([
            'getIconsAndNamesByStage',
        ]),
        stages() {
            return this.getIconsAndNamesByStage(this.payload.journey, this.journeyType)
        },
        journey() {
            return this.journeyType === 'depart' ? this.payload.journey.depart : this.payload.journey.return
        },
    },
    methods: {
        seeDetails() {
            if (this.payload.journey.id) {
                this.$router.push({
                    name: 'Journey',
                    params: {
                        hash: this.hash,
                        journeyId: this.payload.journey.id,
                        journeyType: this.journeyType,
                    },
                })
            }
        },
    },

}
</script>
<style>
.lowest{
    color: #35C06D;
}
.highest{
    color: red;
}
</style>
